const FILE_UPLOAD = 'FILE_UPLOAD';
const FILE_UPLOAD_SUCESSFULLY = 'FILE_UPLOAD_SUCESSFULLY';
const PENDING_APPROVAL_LIST = 'PENDING_APPROVAL_LIST';
const MANUAL_SUBMIT = 'MANUAL_SUBMIT';
const MANUAL_SUCCESS = 'MANUAL_SUCCESS';
const MANUAL_MASTER_DATA = 'MANUAL_MASTER_DATA';
const MANUAL_SUPPLIER_DATA = 'MANUAL_SUPPLIER_DATA';
const MANUAL_SUPPLIER_VALIDATE = 'MANUAL_SUPPLIER_VALIDATE';
const MANUAL_SUPPLIER_FETCH = 'MANUAL_SUPPLIER_FETCH';
const RISK_DETAILS = 'RISK_DETAILS';
const SAVE_FOR_LATER_LIST = 'SAVE_FOR_LATER_LIST';
const SUBMITTED_TO_EU_LIST = 'SUBMITTED_TO_EU_LIST';
const ARCHIVED_LIST = 'ARCHIVED_LIST';
const INVALID_LIST = 'INVALID_LIST';
const EU_SUBMITION_BUTTON = 'EU_SUBMITION_BUTTON';
const SAVE_FOR_LATER_BUTTON_ACTION = 'SAVE_FOR_LATER_BUTTON_ACTION';
const SET_GLA_RESULT_AVAILABLE = 'SET_GLA_RESULT_AVAILABLE';
const ADD_PRODUCER_ACCORDION = 'ADD_PRODUCER_ACCORDION';
const INVALIDATE_BUTTON_ACTION = 'INVALIDATE_BUTTON_ACTION';
const UPDATE_PRODUCER_ACCORDIONS = 'UPDATE_PRODUCER_ACCORDIONS';
const SET_COMMODITY_ROWS = 'SET_COMMODITY_ROWS';
const ADD_COMMODITY_ROW = 'ADD_COMMODITY_ROW';
const UPDATE_COMMODITY_ROWS = 'UPDATE_COMMODITY_ROWS';
const RESET_PRODUCER_ACCORDIONS = 'RESET_PRODUCER_ACCORDIONS';
const EU_FILE_UPLOAD = 'EU_FILE_UPLOAD';
const EU_FILE_UPLOAD_SUCESSFULLY = 'EU_FILE_UPLOAD_SUCESSFULLY';
const EU_SUPPLIER_PENDING_APPROVAL_LIST = 'PENDING_APPROVAL_LIST';
const EU_SUPPLIER_SUBMITTED_TO_EU_LIST = 'SUBMITTED_TO_EU_LIST';
const EU_SUPPLIER_ARCHIVED_LIST = 'EU_SUPPLIER_ARCHIVED_LIST';
export {
  FILE_UPLOAD,
  FILE_UPLOAD_SUCESSFULLY,
  MANUAL_SUCCESS,
  MANUAL_SUBMIT,
  MANUAL_MASTER_DATA,
  PENDING_APPROVAL_LIST,
  MANUAL_SUPPLIER_VALIDATE,
  MANUAL_SUPPLIER_DATA,
  MANUAL_SUPPLIER_FETCH,
  RISK_DETAILS,
  SAVE_FOR_LATER_LIST,
  SUBMITTED_TO_EU_LIST,
  ARCHIVED_LIST,
  INVALID_LIST,
  EU_SUBMITION_BUTTON,
  SAVE_FOR_LATER_BUTTON_ACTION,
  SET_GLA_RESULT_AVAILABLE,
  ADD_PRODUCER_ACCORDION,
  INVALIDATE_BUTTON_ACTION,
  UPDATE_PRODUCER_ACCORDIONS,
  SET_COMMODITY_ROWS,
  ADD_COMMODITY_ROW,
  UPDATE_COMMODITY_ROWS,
  RESET_PRODUCER_ACCORDIONS,
  EU_FILE_UPLOAD_SUCESSFULLY,
  EU_FILE_UPLOAD,
  EU_SUPPLIER_PENDING_APPROVAL_LIST,
  EU_SUPPLIER_SUBMITTED_TO_EU_LIST,
  EU_SUPPLIER_ARCHIVED_LIST,
};
